import React from 'react';
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";

import {setLimitAction} from "./actions";

const PerPage = function ({entity = 'generic'}) {
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const limit = useSelector(state => state[entity + '_limit']);
    const setLimit = function (limit) {
        searchParams.set('limit', limit);
        setSearchParams(searchParams);
        dispatch(setLimitAction(entity, limit));
    }

    return (
        <div className='per-pager'>
            <span>Items per Page: </span>
            <span>
                <a href='#' className={limit === 25 ? 'current' : ''}
                   onClick={event => {
                       event.preventDefault();
                       setLimit(25);
                   }}>25</a>
                </span>
            <span>|</span>
            <span>
                <a href='#' className={limit === 50 ? 'current' : ''}
                   onClick={event => {
                       event.preventDefault();
                       setLimit(50);
                   }}>50</a>
                </span>
            <span>|</span>
            <span>
                <a href='#' className={limit === 100 ? 'current' : ''}
                   onClick={event => {
                       event.preventDefault();
                       setLimit(100);
                   }}>100</a>
                </span>
        </div>
    );
}

PerPage.propTypes = {
    entity: PropTypes.string
};

export default PerPage;
